export default __webpack_public_path__ + "static/media/needs-attention-badge.4566b6ff.svg";